<template>
    <div>
        <template v-if="!newInvoice.document_url">
            <!-- Document url -->
            <div>
                <!-- Informations intervention -->
                <!-- <div class="mb-4">
                    <h2 class="text-lg font-bold text-gray-800 mb-2">Interventions dans ce chantier</h2>
                    <table class="w-full text-xs text-left text-gray-500">
                        <tr v-for="intervention in chantier?.interventions" :key="intervention.id">
                            <td class="border p-2 font-medium text-gray-900">{{ intervention?.reference }}</td>
                            <td class="border p-2 text-sm text-gray-500" v-if="intervention?.date_intervention">{{ new Date(intervention?.date_intervention).toLocaleDateString() }}</td>
                            <td class="border p-2">{{ intervention?.statut?.libelle }}</td>
                            <td class="border p-2">{{ intervention?.intervention_type.nom }}</td>
                            <td class="border p-2">{{ intervention?.appareil?.type + ' ' + intervention?.appareil?.marque }}</td>
                        </tr>
                    </table>
                </div> -->
                <div class="relative">
                    <h2 class="text-lg font-bold text-gray-800 mb-2">Devis / Facture à importer</h2>
                    <input-file @input="readInvoice" key-name="doc-intervention" v-model="newInvoice.document_url" :preview="false" id="inp-document-url" />
                </div>
            </div>
        </template>
        <template v-if="newInvoice.document_url">
            <template v-if="loadingReadInvoice">
                <div class="flex flex-col items-center justify-center py-12">
                    <div class="relative">
                        <div class="w-16 h-16 border-4 border-gray-200 border-t-red-600 rounded-full animate-spin"></div>
                        <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <i class="fas fa-file-invoice text-red-600 text-xl"></i>
                        </div>
                    </div>
                    <p class="mt-6 text-gray-700 font-medium text-lg">Lecture du document...</p>
                    <p class="mt-2 text-gray-500 text-sm">Veuillez patienter quelques instants</p>
                </div>
            </template>
            <template v-if="!loadingReadInvoice">
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <div>
                            <div class="space-y-4 bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <!-- STATUT -->
                                <div>
                                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                                        <i class="fas fa-file-alt text-red-500 mr-1"></i> Statut
                                    </label>
                                    <div class="relative">
                                        <select v-model="newInvoice.status" class="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none" id="inp-status">
                                            <option value="issued">Document créé</option>
                                            <option value="sent">Document envoyé</option>
                                            <option value="relance">Client relancé</option>
                                            <option value="partiel">Paiement partiel</option>
                                            <option value="paid">Entièrement payée</option>
                                        </select>
                                    </div>
                                </div>
                                <!-- Send mail -->
                                <div v-if="newInvoice.status === 'issued'">
                                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                                        <i class="fas fa-envelope text-red-500 mr-1"></i> Envoyer le document par email au client ?
                                    </label>
                                    <div class="relative">
                                        <div class="flex gap-1 max-w-[100px]">
                                            <button 
                                                @click="newInvoice.send_invoice_email = 1" 
                                                :class="newInvoice.send_invoice_email === 1 ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700 hover:opacity-80'"
                                                class="text-sm flex-1 px-4 py-2 rounded-lg font-medium transition duration-200"
                                            >
                                                Oui
                                            </button>
                                            <button 
                                                @click="newInvoice.send_invoice_email = 0" 
                                                :class="newInvoice.send_invoice_email === 0 ? 'bg-slate-900 text-white' : 'bg-gray-200 text-gray-700 hover:opacity-80'"
                                                class="text-sm flex-1 px-4 py-2 rounded-lg font-medium transition duration-200"
                                            >
                                                Non
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="space-y-4 mt-4">
                                <!-- Numéro de facture -->
                                <div>
                                    <label class="text-xs text-gray-600 mr-2">Numéro de facture:</label>
                                    <input type="text" v-model="newInvoice.num_invoice" class="text-xs border border-gray-300 rounded px-2 py-1 w-full" id="inp-num_invoice" />
                                </div>
                                <div class="grid grid-cols-2 gap-2 items-center">
                                    <!-- Type de document -->
                                    <div class="flex-1">
                                        <label class="text-xs text-gray-600 mr-2">Type:</label>
                                        <select v-model="newInvoice.document_type" class="w-full text-xs border border-gray-300 rounded px-2 py-1" id="inp-type-document">
                                            <option value="facture">Facture</option>
                                            <option value="devis">Devis</option>
                                        </select>
                                    </div>
                                    <!-- Date limite paiement -->
                                    <div class="flex-1">
                                        <label class="text-xs text-gray-600 mr-2">Date limite:</label>
                                        <input type="date" v-model="newInvoice.date_limite_paiement" class="text-xs border border-gray-300 rounded px-2 py-1 w-full" id="inp-date_limite_paiement" />
                                    </div>
                                </div>
                                <div class="grid grid-cols-3 gap-2">
                                    <!-- Montant -->
                                    <div class="flex-1">
                                        <label class="text-xs text-gray-600 mr-2">Montant HT:</label>
                                        <input type="number" v-model="newInvoice.total_ht" class="text-xs border border-gray-300 rounded px-2 py-1 w-full" id="inp-total_ht" />
                                    </div>
                                    <div class="flex-1">
                                        <label class="text-xs text-gray-600 mr-2">Montant TVA:</label>
                                        <input type="number" v-model="newInvoice.total_tva" class="text-xs border border-gray-300 rounded px-2 py-1 w-full" id="inp-total_tva" />
                                    </div>
                                    <div class="flex-1">
                                        <label class="text-xs text-gray-600 mr-2">Montant TTC:</label>
                                        <input type="number" v-model="newInvoice.total_ttc" class="text-xs border border-gray-300 rounded px-2 py-1 w-full" id="inp-total_ttc" />
                                    </div>
                                </div>
                            </div>

                            <div class="flex gap-3 mt-8">
                                <button :disabled="loadingUploadDoc" @click="addFacture" class="px-4 py-2 bg-red-600 text-white rounded-lg shadow hover:bg-red-700 transition">
                                    <template v-if="loadingUploadDoc">
                                        <i class="fas fa-spinner fa-spin mr-1"></i> Enregistrement...
                                    </template>
                                    <template v-if="!loadingUploadDoc">
                                        <i class="fas fa-check mr-1"></i> Enregistrer
                                    </template>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Invoice preview -->
                    <div>
                        <div v-if="newInvoice.document_url">
                            <iframe :src="newInvoice.document_url + '#toolbar=0'" class="w-full h-96 border border-gray-300 rounded-lg"></iframe>
                        </div>
                        <div v-else class="w-full h-96 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50">
                            <div class="text-center">
                                <i class="fas fa-file-upload text-4xl text-gray-400 mb-3"></i>
                                <p class="text-gray-600 font-medium">En attente du fichier</p>
                                <p class="text-sm text-gray-500 mt-1">La prévisualisation s'affichera ici</p>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    props: {
        chantierId: {
            type: Number,
            required: true
        },
    },
    watch: {
        chantierId: {
            handler() {
                this.init()
            },
            immediate: true
        }
    },
    data() {
        return {
            newInvoice: {
                document_url: null,
                document_type: 'facture',
                num_invoice: null,
                total_ht: null,
                total_ttc: null,
                total_tva: null,
                status: 'issued',
                send_invoice_email: 0,
            },
            loadingReadInvoice: false,
            loadingUploadDoc: false,
        }
    },
    methods: {
        init() {
            this.newInvoice = {
                document_url: null,
                document_type: 'facture',
                total_ht: null,
                status: 'issued',
                send_invoice_email: 0,
            }
            this.loadingReadInvoice = false
            this.newInvoice.date_limite_paiement = moment().add(30, 'days').format('YYYY-MM-DD');
            // this.$modal.show('modal-add-invoice')
        },
        async readInvoice() {
            if (!this.newInvoice.document_url) return

            this.loadingReadInvoice = true
            try {
                let response = await this.$request.post('/factures/read-invoice', {
                    document_url: this.newInvoice.document_url,
                    chantier_id: this.chantierId,
                })
                if (response.error) {
                    this.$toast.error(response.error)
                    this.newInvoice.document_url = null
                    this.loadingReadInvoice = false
                    return
                }
                if (response.document_type) {
                    this.newInvoice.document_type = response.document_type
                }
                if (response.total_ht) {
                    this.newInvoice.total_ht = response.total_ht
                }
                if (response.total_ttc) {
                    this.newInvoice.total_ttc = response.total_ttc
                }
                if (response.total_tva) {
                    this.newInvoice.total_tva = response.total_tva
                }
                if (response.date_limite_paiement) {
                    this.newInvoice.date_limite_paiement = response.date_limite_paiement
                }
                if (response.num_invoice) {
                    this.newInvoice.num_invoice = response.num_invoice
                }
                if (response.status) {
                    this.newInvoice.status = response.status
                }
            } catch (error) {
                console.error('Error reading invoice:', error)
                this.$toast.error('Impossible de lire le document. Veuillez vérifier que le fichier est une facture valide.')
            } finally {
                this.loadingReadInvoice = false
            }
        },

        async addFacture() {
            if (!this.chantierId) return

            const validation = this.$inpError([
                'inp-type-document:required',
                'inp-document-url:required',
                'inp-total_ht:required|min=0',
                'inp-total_ttc:required|min=0',
                'inp-total_tva:required|min=0',
                'inp-date_limite_paiement:required',
                'inp-num_invoice:required',
                'inp-status:required',
            ]);

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            let payload = {
                chantier_id: this.chantierId,
                document_url: this.newInvoice.document_url,
                document_type: this.newInvoice.document_type,
                total_ht: this.newInvoice.total_ht,
                total_ttc: this.newInvoice.total_ttc,
                total_tva: this.newInvoice.total_tva,
                status: this.newInvoice.status,
                send_invoice_email: this.newInvoice.send_invoice_email ? 1 : 0,
                date_limite_paiement: this.newInvoice.date_limite_paiement,
                num_invoice: this.newInvoice.num_invoice,
            }

            this.loadingUploadDoc = true
            await this.$request.post('/factures/upload-document', payload)
            this.loadingUploadDoc = false

            this.$modal.hide('modal-add-invoice')
            // this.getInterventions()

            // Reset form
            this.newInvoice = {
                document_url: null,
                document_type: 'facture',
                total_ht: null,
                total_ttc: null,
                total_tva: null,
                date_limite_paiement: null,
                status: 'issued',
                send_invoice_email: 0,
                num_invoice: null,
            }

            this.$forceUpdate()

            this.$emit('invoice-created')
        },
    },
    mounted () {
        this.init()
    },
}
</script>

<style lang="scss" scoped>

</style>